import * as actions from "../actionTypes";
import Actions from "../actions";
import httpClient from "../../utils/HttpClient";
import { server } from "../../utils/Constants";
import { call, put, delay } from "redux-saga/effects";

export function* getReviewClient({ id }) {
  try {
    yield put(Actions.getReviewClientFetching());

    const response = yield call(
      httpClient.get,
      `${server.POST_REVIEW_CLIENT}/${id}`
    );

    if (response.status == 200 && response.data.data) {
      yield put(Actions.getReviewClientSuccess(response.data.data.data));
    }
  } catch (error) {
    yield put(Actions.getReviewClientFailed());
  }
}
